
import Vue from 'vue';
import App from './App';
import qs from 'qs';
import ElementUI from 'element-ui';  // 使用import
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import 'lib-flexible/flexible';
import store from "./store";
import http from "./api/http.js";
import OSSUploader from "./api/ossUpload.js";
import tabNav from './components/tabNav.vue';
import noData from "./components/noData.vue";
import local from "./api/local.js";
import BaiduMap from 'vue-baidu-map';
import SignedImage from "./components/SignedImage.vue";
import './components/alert';
Vue.use(BaiduMap, {
  ak: 'x8FCGx4IHGaCEC3qV0AoLukulQtvjq3H'  //这个地方是官方提供的ak密钥
})
Vue.component('noData',noData);
Vue.component('tabNav',tabNav);
Vue.component('signed-image',SignedImage);
Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.prototype.$http=http;
Vue.prototype.$local=local;
Vue.prototype.$OSSUploader=OSSUploader;
// 私有 bucket 下，上传后返回的是 String 对象（主值=裸URL入库，.previewUrl=签名URL用于即时显示）
// 模板里 :src="xxx" 改成 :src="$signedUrl(xxx)" 即可兼容新老数据：
//   - 新上传的 String 对象 → 拿 .previewUrl（签名URL，2小时有效）
//   - 后端列表返回的裸URL字符串 → 直接用（后端已签名）
//   - null/undefined/空 → 返回空字符串，避免渲染报错
Vue.prototype.$signedUrl=function(url){
  if(!url) return '';
  if(typeof url==='object' && url!==null && url.previewUrl) return url.previewUrl;
  return url;
};
// 视频缩略图专用：先取签名URL，再附加 ?x-oss-process=video/snapshot,... 缩略图参数
// 模板里 :src="it.indexOf('.mp4')==-1?it:it+'?x-oss-process=...'" 改成 :src="$videoPoster(it)"
// ⚠️ 签名URL已包含 ? 参数，追加缩略图参数时必须用 & 而非 ?
Vue.prototype.$videoPoster=function(url){
  const u=this.$signedUrl(url);
  if(!u) return '';
  if(typeof u==='string' && u.indexOf('.mp4')==-1) return u;
  const sep=u.indexOf('?')!==-1?'&':'?';
  return u+sep+'x-oss-process=video/snapshot,t_1000,f_jpg,w_600,h_600,m_fast';
};
// ===== 私有 bucket 签名 URL 过期重签 =====
// 后端对常量资源（品牌logo/用户头像/菜单icon）返回带 2h 签名的 URL，
// 这些 URL 在登录时被持久化进 localStorage；2h 过期后刷新浏览器即裂图。
// 这里提供三个能力：
//   1) $isOssExpired(url)    本地判断签名是否临近过期（剩余 < 5 分钟）
//   2) $reSignOss(url)       剥签名 → 调 /v1/upload/signUrl 重签 → 返回新 URL（带并发去重）
//   3) $reSignOssBatch(urls) 一次性批量重签，返回同序数组（失败返回原值，绝不返回空）
const OSS_DOMAIN='oss.jinding.work';
const OSS_SIGN_RE=/[?&](OSSAccessKeyId|Signature|Expires)=/;
function stripOssSign(url){
  if(typeof url!=='string') return url;
  if(url.indexOf(OSS_DOMAIN)!==-1 && OSS_SIGN_RE.test(url)){
    return url.split('?')[0];
  }
  return url;
}
Vue.prototype.$stripOssSign=stripOssSign;
Vue.prototype.$isOssExpired=function(url){
  if(typeof url!=='string') return false;
  const m=url.match(/[?&]Expires=(\d+)/);
  if(!m) return false; // 无 Expires 参数（裸URL或已失效无参）→ 不判过期
  const expSec=parseInt(m[1],10);
  return Date.now()/1000 >= (expSec-300); // 剩余 < 5 分钟即视为过期
};
const _reSignCache=Object.create(null);
Vue.prototype.$reSignOss=function(url){
  if(!url || typeof url!=='string') return Promise.resolve(url);
  if(url.indexOf(OSS_DOMAIN)===-1) return Promise.resolve(url);
  const bare=stripOssSign(url);
  if(_reSignCache[bare]) return _reSignCache[bare];
  const p=OSSUploader.getSignedUrls([bare]).then(res=>{
    if(res && res[0]) return res[0];
    throw new Error('re-sign empty');
  }).catch(err=>{
    delete _reSignCache[bare];
    throw err;
  });
  _reSignCache[bare]=p;
  return p;
};
Vue.prototype.$reSignOssBatch=function(urls){
  const list=(urls||[]).filter(u=>typeof u==='string' && u.indexOf(OSS_DOMAIN)!==-1);
  if(list.length===0) return Promise.resolve([]);
  const bare=list.map(stripOssSign);
  return OSSUploader.getSignedUrls(bare).catch(err=>{
    console.warn('批量重签失败，沿用原值:',err);
    return list; // 失败时返回原签名 URL，不破坏 storage
  });
};

const getMyNoticeList=function(){
  if(this.$route.path=='/login'){return}
  var nowTime=new Date().getTime();
  var pastTime=this.$local.get('pastTime')||0;
  if(nowTime-pastTime<=(15*60*1000)){
    console.log('工作流提醒时间未到，剩余：',nowTime-pastTime)
  }else{
    this.$http.get('/v1/workflow/getMyNoticeList').then(res => {
      if(res.data.status==1) {
        this.$store.commit('changeWorkFlow',res.data.data);
        if(this.$route.path!='/my_workflow'&&res.data.data.list.length>0){
          this.$alertBox('你有'+res.data.data.list.length+'个待办工作流',{
            content_list:res.data.data.list,
            sence:'workFlow',
          	cancelText:'稍后提醒',
          	confirmText:'去处理'
          },(item) => {
            console.log('这是去处理')
            this.$router.push({
              path:'/my_workflow',
              query:{
                fastDeal:true
              }
            })
          });
        }
        // ===== 转正提醒待审批弹框（后端在 data 同级新增 archives_list 一维数组）=====
        // 与 workFlow 共用同一接口，但走独立 throttle 键（regRemindTime），互不影响"稍后提醒"
        var regArr = (res.data.data && res.data.data.archives_list) || [];
        var regMinutes = (res.data.data && res.data.data.minutes) || 15;
        var regPast = this.$local.get('regRemindTime') || 0;
        if (regArr.length > 0 && this.$route.path !== '/archive_approval') {
          var regNow = new Date().getTime();
          if (regNow - regPast > regMinutes * 60 * 1000) {
            this.$alertBox('你有 ' + regArr.length + ' 条转正提醒待审批', {
              content_list: regArr,
              sence: 'regularization',
              cancelText: '稍后提醒'
            }, () => {});
          }
        }
      }else{
        this.$message.error({message:res.data.message});
      }
    }).catch((res)=>{});
  }
  var s_nowTime=new Date().getTime();
  var s_pastTime=this.$local.get('dealTime')||0;
  if(s_nowTime-s_pastTime<=(15*60*1000)){
    console.log('品项确认提醒时间未到，剩余：',s_nowTime-s_pastTime)
  }else{
    var param={
      status:0
    }
    this.$http.get('/v1/notice/getMyReiceiveNoticeList?'+qs.stringify(param,{arrayFormat: 'repeat'})).then(resp => {
      if(resp.data.status==1) {
        if(this.$route.path!='/shopping_order_detail'&&resp.data.data.length>0){
          var title_list=[
            {name:'序号',width:10,key:'sort'},
            {name:'门店',width:20,key:'depart_name'},
            {name:'推送时间',width:20,key:'notice_time'},
            {name:'订单号',width:25,key:'ordersn'},
            {name:'品项数量',width:10,key:'data_list'},
            {name:'操作',width:15,key:'options'}
          ]
          this.$alertBox('你有'+resp.data.data.length+'条物流品项收货消息待确认',{
            sence:'PerfBudget',
            title_list,
            content_list:resp.data.data,
            act_type:'notice',
          	cancelText:'稍后处理',
          },(dd) => {
            console.log(dd)
            if(dd){
              var Link = this.$router.resolve({
                  path:'/shopping_order_detail',
                  query:{order_id:dd}
              })
              window.open(Link.href, '_blank')
            }
          });
        }
      }else{
        this.$message.error({message:resp.data.message});
      }
    }).catch((resp)=>{});
  }
}
Vue.prototype.$getMyNoticeList=getMyNoticeList;

const getOfflineOrderPendingData=function(){
  this.$http.get('/v1/supply/getOfflineOrderPendingData').then(res => {
    if (res.data.status==1) {
      this.$store.commit('changeWaitTip',res.data.data)
    }else{
      this.$message.error({message:res.data.message});
    }
  }).catch((res)=>{});
}
Vue.prototype.$getOfflineOrderPendingData=getOfflineOrderPendingData;

const getPermission=function(){
  this.$http.get('/v1/basic/getPermissionList').then(res => {
    if (res.data.status==1) {
		this.$local.set('permission',res.data.data);
    }else{
      this.$message.error({message:res.data.message});
    }
  }).catch((res)=>{});
}
Vue.prototype.$getPermission=getPermission;

const permission=function(e){
  var list=this.$local.get('permission');
  if(list&&list[0]&&list[0].route_name=='all'){
    return true;
  }else{
    var arr=list.map(obj => obj.route_name);
    if(arr.indexOf(e)!=-1){
      return true;
    }else{
      return false;
    }
  }
}
Vue.prototype.$permission=permission;

var is_mobi =
  navigator.userAgent
    .toLowerCase()
    .match(
      /(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i
    ) != null;
if (is_mobi) {
  // window.location.href = "手机端"
  store.commit("changeMobi", "mobile");
  // Vue.prototype.$pc = false
  console.log("手机端");
} else {
  // window.location.href = "pc端"
  store.commit("changeMobi", "pc");
  // Vue.prototype.$pc = true
  console.log("pc端");
}

var flag;
router.beforeEach((to,form,next)=>{
  if(to.path=='/monitoring_samples'&&Vue.prototype.$permission('supply.focusFoodMonitorDemo.edit')){
    flag=true;
    next();
  }else{
    if(flag&&!store.state.is_save){
      Vue.prototype.$confirm('是否保存本次查询结果为样本数据？','提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        Vue.prototype.$http.post('/v1/supply/saveFocusFoodMonitorDemo',store.state.flag).then(res => {
          if(res.data.status==1){
            flag=false;
            next();
            Vue.prototype.$message({
              message:res.data.message,
              type: 'success'
            });
          }else{
            Vue.prototype.$message.error({message:res.data.message});
          }
        }).catch((res)=>{});
      }).catch(()=>{
        flag=false;
        next();
      })
    }else{
      next();
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
